import { render, staticRenderFns } from "./LinkContent.vue?vue&type=template&id=60dc3d7e&"
import script from "./LinkContent.vue?vue&type=script&lang=js&"
export * from "./LinkContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports